import React from 'react'

const Card = ({num,des}) => {
  return (
    <div className=' bg-yellow-3 p-5 flex flex-col items-end justify-between w-[300px] h-[400px] xl:w-[400px] xl:h-[400px] border-4 border-primario text-primario rounded-lg'>
        <span className='text-5xl xl:text-6xl font-bold'>{num}</span>
        <p className='text-xl xl:text-2xl'>{des}</p>
    </div>
  )
}

export default Card